import { render, staticRenderFns } from "./UploadFinshDraft.vue?vue&type=template&id=2fd5aa32&scoped=true&"
import script from "./UploadFinshDraft.vue?vue&type=script&lang=js&"
export * from "./UploadFinshDraft.vue?vue&type=script&lang=js&"
import style0 from "./UploadFinshDraft.vue?vue&type=style&index=0&id=2fd5aa32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5aa32",
  null
  
)

export default component.exports